import React from 'react';
import { IMAGES, INCLUDES, INCLUDES_TITLE } from '../constants/content';
import { Reveal } from './Reveal';
export function IncludesStack() {
  return <section className="w-full bg-white py-12 b760:py-16" data-id="element-152" data-mp="musi5uavlkiz">
      <div className="mx-auto max-w-3xl px-4 b720:px-6" data-id="element-153" data-mp="84uqh4dqmcp1">
        <Reveal className="text-center" data-id="element-154" data-mp="d2w8dlzfg5yx">
          <h2 className="font-display text-2xl font-700 uppercase leading-tight text-night b640:text-4xl" data-id="element-155" data-mp="d3xtyke2kauw">
            {INCLUDES_TITLE}
          </h2>
        </Reveal>

        <Reveal className="mt-8" data-id="element-156" data-mp="15ra57yes4w8w">
          <img src={IMAGES.stack} alt="Todo lo que incluye Pollería Rentable 2026" width={1200} height={900} loading="lazy" decoding="async" className="h-auto w-full rounded-2xl bg-bordo-deep" data-id="element-157" data-mp="15q8uxw5l8ds8" />
        </Reveal>

        <Reveal className="mt-8" data-id="element-158" data-mp="3bjqrjeeg188a">
          <ul className="space-y-3" data-id="element-159" data-mp="3bmv1ytii507e">
            {INCLUDES.map(item => <li key={item.text} className={`flex gap-3 rounded-lg px-4 py-3 text-sm leading-relaxed b640:text-base ${item.star ? 'border-l-4 border-mustard bg-bordo text-cream' : 'border-l-4 border-night/15 bg-cream text-night/90'}`} data-id="element-160" data-mp="3gkwj38wdapg8">
                <span className={`shrink-0 font-700 ${item.star ? 'text-mustard' : 'text-mustard-dark'}`} aria-hidden="true" data-id="element-161" data-mp="20ew8segj0qgh">
                  {item.star ? '★' : '✓'}
                </span>
                <span data-id="element-162" data-mp="2ad3f83d6vq48">
                  {item.text}
                  {item.value && <span className={`ml-1 font-700 ${item.star ? 'text-mustard' : 'text-bordo'}`} data-id="element-163" data-mp="2o3ypnk3c6f9x">
                      {item.value}
                    </span>}
                </span>
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}